import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import CarouselSlider from "components/atoms/TemplateCarouselSlider";
import { Slide } from "pure-react-carousel";
import ReactHtmlParser from "react-html-parser";
import { useDispatch, useSelector } from "react-redux";
import {
  isActiveSosongGuideModal,
  isActiveSosongFlowChartModal,
} from "modules/actions/statusMenu";
import {
  selectCategory,
  listBtnCategory,
} from "modules/actions/selectCategory";
import { setLevel1List } from "modules/actions/guideMap";
import { cleanHTML, removeLiTabIndex } from "helper/index";

/**
 * Text
 */
const Arrow = () => {
  return (
    <svg
      width="18"
      height="15"
      viewBox="0 0 19 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="_url_svg"
        d="M13.9784 11.0274L12.859 9.97579L13.9784 8.92422C14.2725 8.64798 14.5058 8.32004 14.6649 7.95912C14.824 7.5982 14.906 7.21136 14.906 6.8207C14.906 6.43004 14.824 6.04321 14.6649 5.68229C14.5058 5.32137 14.2725 4.99342 13.9784 4.71719C13.6844 4.44095 13.3353 4.22182 12.9511 4.07232C12.5669 3.92283 12.1551 3.84588 11.7392 3.84588C11.3233 3.84588 10.9116 3.92283 10.5273 4.07232C10.1431 4.22182 9.79404 4.44095 9.49998 4.71719L8.38056 5.76876L7.26115 4.71719L8.38056 3.66561C9.27381 2.84006 10.4781 2.37952 11.7312 2.38431C12.9843 2.38911 14.1846 2.85884 15.0706 3.6912C15.9567 4.52356 16.4567 5.65111 16.4618 6.82823C16.4669 8.00535 15.9767 9.13668 15.0979 9.97579L13.9784 11.0274ZM11.7388 13.1313L10.6194 14.1828C10.1796 14.6027 9.65574 14.9367 9.07791 15.1654C8.50009 15.3941 7.87977 15.5131 7.25274 15.5155C6.62571 15.5179 6.00438 15.4037 5.42459 15.1794C4.8448 14.9551 4.31802 14.6251 3.87464 14.2086C3.43126 13.7921 3.08005 13.2973 2.84128 12.7526C2.6025 12.208 2.48088 11.6243 2.48344 11.0353C2.48599 10.4462 2.61267 9.86351 2.85615 9.32071C3.09964 8.7779 3.45513 8.28575 3.9021 7.87265L5.02152 6.82108L6.14094 7.87265L5.02152 8.92422C4.72746 9.20046 4.4942 9.5284 4.33506 9.88932C4.17591 10.2502 4.094 10.6371 4.094 11.0277C4.094 11.4184 4.17591 11.8052 4.33506 12.1662C4.4942 12.5271 4.72746 12.855 5.02152 13.1313C5.31558 13.4075 5.66468 13.6266 6.04889 13.7761C6.4331 13.9256 6.84489 14.0026 7.26075 14.0026C7.67661 14.0026 8.08841 13.9256 8.47261 13.7761C8.85682 13.6266 9.20592 13.4075 9.49998 13.1313L10.6194 12.0797L11.7388 13.1313ZM11.7388 5.76876L12.859 6.82108L7.26115 12.0789L6.14094 11.0274L11.7388 5.7695V5.76876Z"
        fill="rgb(64,96,157)"
      />
    </svg>
  );
};

const onSosongGuide = (dispatch) => {
  dispatch(isActiveSosongGuideModal());
};

const ListBtnElement = ({ onClickEvt, data, styleDef, fontSize, btnIndex, tabIndex }) => {
  const dispatch = useDispatch();
  const guideArr = useSelector((state) => state.guideMapGetList.guideMapList);
  const clickCategory = guideArr.filter(
    (obj) => obj.Intent === data.intentName
  );
  const style = { ...styleDef, ...fontSize };
  const onSosongFlowChart = () => {
    dispatch(selectCategory(clickCategory[0].category));
    dispatch(listBtnCategory(clickCategory));
    dispatch(setLevel1List());
    dispatch(isActiveSosongFlowChartModal());
  };
  
  // url 있을 때 button에 속성 추가
  const isUrl = data.action === 'url';
  
  return (
    <div className="_list_btn_text">
      <button
        type="button"
        style={style}
        className="tabButton"
        index={btnIndex}
        tabIndex={tabIndex}
        aria-label={isUrl ? data.label + ' 새 창 열림' : undefined} 
        role={isUrl ? 'link' : undefined}
        onClick={(e) => {
          if (data.label !== "소송절차 안내도 창에서 보기") {
            onClickEvt(data.value, data.action, data.label);
          } else {
            // onSosongGuide(dispatch);
            onSosongFlowChart();
          }
        }}
      >
        {ReactHtmlParser(data.label)}
        {data.action === "url" ? <Arrow /> : ""}
      </button>
    </div>
  );
};

const TextCardElement = ({ onClickEvt, data }) => {
  return (
    <div
      className="_text_card_card_button"
      idx={idx}
      onClick={(e) => onClickEvt(data.value, data.action, data.label)}
    >
      {ReactHtmlParser(data.label)}
    </div>
  );
};
const TextCard = ({ boxStyle, item, viewType, onClickEvt, fontStyle }) => {
  const [cardHeight, setCardHeight] = useState({ height: 0 });
  const [cardWidth, setCardWidth] = useState();
  const [firstSlideWithButtonIndex, setFirstSlideWithButtonIndex] = useState(-1);
  
  let maxHeight = 0;
  const setHeight = (ref, tempItem, setArrowCircleHeight) => {
    const temp = [];
    if (ref !== null) {
      temp.push(ref.clientHeight);
      if (maxHeight < ref.clientHeight) {
        maxHeight = ref.clientHeight;
        setCardHeight({ height: maxHeight });
      }
      if (cardHeight.height <= 500) {
        setArrowCircleHeight(cardHeight);
      }
    }
  };
  
  const { items, type, intentName } = item;
  if (intentName) {
    items.forEach((obj) => {
      obj.button?.forEach((btnObj) => {
        btnObj.intentName = intentName;
      });
    });
  }
  const reRenderFontStyle = { ...boxStyle, ...fontStyle, ...cardHeight };
  const { fontSize } = reRenderFontStyle;
  const titleFontStyle = { fontSize: fontStyle.fontSize + 1 };
  const slideBoxSet = boxStyle;

  const slideBoxSetStyle = {
    width: `${slideBoxSet.width - 10}px`,
    margin: `0 ${slideBoxSet.margin}px`,
  };
  const slideLength = items.length;  
  
  const updatedReRenderFontStyle = {
    width: `${boxStyle.width - 40}px`,
    height: `${cardHeight.height}px`,
    fontSize,
  }

     
  useEffect(() => {
    
    // 웹접근성 carousel 오류에 대한 수정
    // Remove tabIndex from carousel items when component mounts
    const removeTabIndex = () => {
      removeLiTabIndex();
    }

    removeTabIndex();
  }, []);

  const constentSet = (setArrowCircleHeight) => {
    return (
      <>
        {items.map((tempItem, idx) => {
          return (
            <Slide
              key={`slide_${idx}`}
              className="_list_btn_card"
              style={slideBoxSetStyle}
            >
              <div key={`${type}_${idx}`} className="_text_div">
                <div
                  className="_message3"
                  style={updatedReRenderFontStyle}
                  ref={(ref) => setHeight(ref, tempItem, setArrowCircleHeight)}
                >
		              <div className="_message_item_wrapper" style={{marginLeft: '1em', marginRight: '1em'}}>
                  {items.length - 1 === idx ? (
                    <div
                      className="_message_title"
                      style={titleFontStyle}
                      aria-label={cleanHTML(tempItem.textbox?.title)}
                    >
                      {ReactHtmlParser(tempItem.textbox?.title)}
                      {ReactHtmlParser(tempItem.text?.desc)}
                    </div>
                  ) : (
                    <div
                      className="_message_title"
                      style={titleFontStyle}
                    >
                      <h2 className="_h2_title">
                        {ReactHtmlParser(tempItem.textbox?.title)}
                        {ReactHtmlParser(tempItem.text?.desc)}
                      </h2>
                    </div>
                  )}
                    <div className="_message_scroll_section">
            		      {ReactHtmlParser(tempItem.textbox?.desc)}
            		    </div>
             
                  {tempItem.button?.map((buttonItem, index) => {
                    return buttonItem.label && buttonItem.value ? (
                      <ListBtnElement
                        key={`button_${index}`}
                        onClickEvt={onClickEvt}
                        data={buttonItem}
                        fontSize={{ fontSize }}
                      />
                    ) : (
                      ""
                    );
                  })}
                 </div> 

                </div>
              </div>
            </Slide>
          );
        })}
      </>
    );
  };
  return (
    <>
      <div className="_carousel_button_div">
        <CarouselSlider
          slideBoxSet={slideBoxSet}
          contentCount={slideLength}
          contentSet={constentSet}
        />
      </div>
    </>
  );
};
TextCard.propTypes = {
  boxStyle: PropTypes.object,
  item: PropTypes.object,
  viewType: PropTypes.string,
  onClickEvt: PropTypes.func,
  fontStyle: PropTypes.object,
};
TextCard.defaultProps = {
  boxStyle: {},
  fontStyle: {},
  item: {},
  viewType: "advise", // advise, simulator, knowledge
  onClickEvt: null,
};

TextCardElement.propTypes = {
  data: PropTypes.object,
  onClickEvt: PropTypes.func,
};
TextCardElement.defaultProps = {
  data: {},
  onClickEvt: null,
};
ListBtnElement.propTypes = {
  data: PropTypes.object,
  onClickEvt: PropTypes.func,
  styleDef: PropTypes.object,
  fontSize: PropTypes.number,
  btnIndex: PropTypes.number,
  tabIndex: PropTypes.number,
};
ListBtnElement.defaultProps = {
  data: {},
  onClickEvt: null,
  styleDef: {},
  fontSize: null,
  btnIndex: 0,
  tabIndex: 0,
};

export default TextCard;
